import React from "react";
import { useNavigate } from "react-router-dom";
import { Trainer } from "./Trainer";

const Home = () => {
  const role = JSON.parse(localStorage.getItem("user_data")).role;
  console.log(role, "role");
  const navigate = useNavigate();
  return (
    <div>
      {role === "Admin" ? (
        <div>Admin</div>
      ) : role === "Trainer" ? (
        <Trainer />
      ) : role === "Student" ? (
        <div>Student</div>
      ) : (
        <div>Not Logged In</div>
      )}
    </div>
  );
};

export { Home };
